export default __webpack_public_path__ + "media/images/react_icons/calendar_filters_white-b954e9c918e8af61cde14329323c7135.svg";